import React, { useState } from "react";
import { PageShell } from "../PageShell/index";

export function FarmerCorner() {
  const [activeTab, setActiveTab] = useState("cow");
  return (
    <PageShell title="Farmer Corner | ZFAST Agritech India" description="ZFAST Parivaar farmer corner" path="/farmer-corner">
      <style>{`
    :root{
      --zfast-green:#0f6b3a;
      --zfast-green-2:#198754;
      --zfast-dark:#103824;
      --zfast-light:#eefaf1;
      --zfast-soft:#f7fff9;
      --zfast-line:#d8eddd;
      --zfast-gold:#f5b041;
      --text:#26352d;
      --muted:#66766d;
      --white:#ffffff;
      --shadow:0 18px 45px rgba(15,107,58,.13);
      --radius:24px;
      --max:1120px;
    }

    *{box-sizing:border-box;margin:0;padding:0}
    body{
      font-family:inherit;
      color:var(--text);
      background:
        radial-gradient(circle at 8% 4%, rgba(25,135,84,.13), transparent 25%),
        radial-gradient(circle at 92% 12%, rgba(245,176,65,.15), transparent 24%),
        linear-gradient(180deg,#ffffff 0%,#f6fff8 55%,#ffffff 100%);
      line-height:1.65;
      overflow-x:hidden;
    }
    img{max-width:100%;display:block}
    a{color:inherit;text-decoration:none}

    .page-shell{width:min(var(--max), calc(100% - 32px));margin:0 auto;padding:48px 0 70px}

    .section{margin:0;padding:46px 0;border-bottom:1px solid var(--zfast-line)}
    .section:last-child{border-bottom:0}
    .section-card{
      background:transparent;
      border:0;
      border-radius:0;
      box-shadow:none;
      padding:0;
      position:relative;
      overflow:visible;
    }

    .eyebrow{
      display:inline-flex;
      align-items:center;
      gap:8px;
      padding:7px 14px;
      border-radius:999px;
      color:var(--zfast-green);
      background:var(--zfast-light);
      border:1px solid var(--zfast-line);
      font-size:13px;
      font-weight:700;
      letter-spacing:.4px;
      text-transform:uppercase;
      margin-bottom:14px;
    }
    .eyebrow:before{content:none}
    h1,h2,h3{line-height:1.18;color:var(--zfast-dark);font-family:inherit}
    h1{font-size:clamp(34px,5vw,64px);margin-bottom:18px;max-width:760px}
    h2{font-size:clamp(28px,3.3vw,44px);margin-bottom:16px}
    h3{font-size:clamp(20px,2vw,27px);margin-bottom:10px}
    p{font-size:17px;color:var(--text);margin-bottom:16px}
    .lead{font-size:19px;color:#405349;max-width:780px}
    .muted{color:var(--muted)}

    .hero{
      min-height:500px;
      display:grid;
      grid-template-columns:1.05fr .7fr;
      gap:36px;
      align-items:center;
      padding:0;
      background:transparent;
    }
    .hero-visual{
      min-height:420px;
      display:flex;
      align-items:flex-end;
      justify-content:center;
      position:relative;
    }
    .hero-visual img{position:relative;z-index:1;max-height:430px;object-fit:contain;filter:drop-shadow(0 20px 30px rgba(16,56,36,.14))}
    .hero-stats{display:flex;gap:12px;flex-wrap:wrap;margin-top:26px}
    .pill{padding:10px 15px;background:#fff;border:1px solid var(--zfast-line);border-radius:999px;color:var(--zfast-green);font-weight:700;font-size:14px}

    .split{display:grid;grid-template-columns:.85fr 1.15fr;gap:34px;align-items:center}
    .split.reverse{grid-template-columns:1.12fr .88fr}
    .image-box{
      background:transparent;
      border:0;
      border-radius:0;
      padding:0;
      box-shadow:none;
    }
    .image-box.center{display:flex;align-items:center;justify-content:center;min-height:230px}
    .image-box img{border-radius:14px;margin:auto}
    .icon-img img{max-height:210px;object-fit:contain}

    ul{padding-left:0;list-style:none;margin:20px 0 0}
    li{position:relative;padding-left:34px;margin:13px 0;font-size:16.5px;color:#33463c}
    li:before{
      content:"✓";
      position:absolute;left:0;top:0;
      width:auto;height:auto;border-radius:0;
      display:inline-block;
      background:transparent;
      color:var(--zfast-green);font-size:16px;font-weight:900;
    }

    .note-box{
      margin-top:22px;
      padding:18px 20px;
      border-radius:18px;
      background:linear-gradient(135deg,#fff8e7,#f5fff7);
      border:1px solid #f0e2b9;
      color:#4b5531;
      font-weight:700;
    }

    .ai-list li:before{content:"AI";font-size:9px;background:var(--zfast-gold);color:#243426}

    .bcs-intro{display:grid;grid-template-columns:1fr .95fr;gap:26px;align-items:center;margin-top:14px}
    .bcs-scale{display:grid;grid-template-columns:repeat(5,1fr);gap:16px;margin-top:24px}
    .bcs-card{
      background:transparent;
      border:0;
      border-radius:0;
      padding:0;
      text-align:center;
      box-shadow:none;
    }
    .bcs-card img{width:100%;aspect-ratio:1.15/1;object-fit:cover;border-radius:12px;margin-bottom:10px}
    .bcs-card strong{display:block;color:var(--zfast-green);font-size:18px}

    .pig-bcs-guide{display:grid;grid-template-columns:.95fr 1.05fr;gap:24px;align-items:center;margin-top:18px}
    .pig-bcs-hero{
      background:#fff;
      border:1px solid var(--zfast-line);
      border-radius:18px;
      padding:12px;
      overflow:hidden;
    }
    .pig-bcs-hero img{width:100%;height:auto;display:block;border-radius:14px}
    .pig-bcs-points{margin-top:12px}
    .pig-bcs-points li{margin:10px 0}
    .pig-bcs-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:16px;margin-top:26px}
    .pig-bcs-card{
      background:#fff;
      border:1px solid var(--zfast-line);
      border-radius:16px;
      padding:14px 12px 16px;
      text-align:center;
    }
    .pig-bcs-photo{
      width:100%;
      aspect-ratio:1.05/1;
      object-fit:cover;
      object-position:center;
      border-radius:12px;
      margin:0 auto 10px;
      background:#f7fff9;
      border:1px solid var(--zfast-line);
    }
    .pig-bcs-card strong{display:block;color:var(--zfast-green);font-size:18px;margin-bottom:6px}
    .pig-bcs-card p{font-size:14px;line-height:1.45;color:var(--muted);margin:0}

    .calculator-section{text-align:center;padding:42px 34px}
    .tool-tabs{
      display:inline-flex;
      gap:8px;
      padding:6px;
      border-radius:999px;
      background:#eefaf1;
      border:1px solid var(--zfast-line);
      margin:18px auto 24px;
      flex-wrap:wrap;
      justify-content:center;
    }
    .tool-tab{
      appearance:none;
      border:0;
      cursor:pointer;
      border-radius:999px;
      padding:10px 18px;
      font-weight:800;
      color:var(--zfast-green);
      background:transparent;
      transition:.2s ease;
      font-family:inherit;
    }
    .tool-tab.active{
      background:var(--zfast-green);
      color:#fff;
      box-shadow:0 10px 22px rgba(15,107,58,.18);
    }
    .tool-panel{display:none}
    .tool-panel.active{display:block}
    .calculator-grid{display:grid;grid-template-columns:1fr auto;gap:24px;align-items:center;text-align:left;margin-top:8px}
    .calc-buttons{display:flex;gap:14px;flex-wrap:wrap;margin-top:22px}
    .btn{
      display:inline-flex;align-items:center;justify-content:center;
      min-height:48px;padding:12px 20px;
      border-radius:999px;
      font-weight:800;
      background:var(--zfast-green);
      color:#fff;
      box-shadow:0 12px 25px rgba(15,107,58,.22);
      transition:transform .2s ease, background .2s ease;
    }
    .btn:hover{transform:translateY(-2px);background:#0b5730}
    .btn.alt{background:#fff;color:var(--zfast-green);border:1px solid var(--zfast-line);box-shadow:none}
    .cow-gif{max-width:190px;border-radius:0}
    .pig-illustration{width:min(230px,100%);height:auto;display:block;margin:0 auto}
    .pig-illustration svg{width:100%;height:auto;display:block;filter:drop-shadow(0 16px 24px rgba(16,56,36,.12))}


    .section-title-center{text-align:center;max-width:820px;margin:0 auto 26px}
    .decor-line{height:4px;width:84px;background:linear-gradient(90deg,var(--zfast-green),var(--zfast-gold));border-radius:999px;margin:16px 0 0}
    .section-title-center .decor-line{margin:16px auto 0}

    @media(max-width:900px){
      .page-shell{width:min(100% - 22px, var(--max));padding:28px 0 46px}
      .section{padding:34px 0}
      .section-card,.hero{padding:0;border-radius:0}
      .hero,.split,.split.reverse,.bcs-intro,.calculator-grid{grid-template-columns:1fr}
      .hero{min-height:auto;background:transparent}
      .hero-visual{min-height:310px;order:-1}
      .hero-visual img{max-height:315px}
      .bcs-scale{grid-template-columns:repeat(2,1fr)}
      .pig-bcs-guide{grid-template-columns:1fr}
      .pig-bcs-grid{grid-template-columns:repeat(2,1fr)}
      .cow-gif{max-width:150px;margin:auto}
      .pig-illustration{max-width:180px}
      p,.lead{font-size:16px}
    }
    @media(max-width:520px){
      .bcs-scale{grid-template-columns:1fr}
      .pig-bcs-grid{grid-template-columns:1fr}
      .calc-buttons{display:grid}
      .tool-tabs{width:100%;border-radius:18px}
      .tool-tab{flex:1 1 100%}
      .btn{width:100%}
      h1{font-size:34px}
      h2{font-size:27px}
      .hero-stats{display:grid;grid-template-columns:1fr}
      .pill{text-align:center}
    }
  `}</style>
      <div className="page-shell">
        


  <main className="page-shell">

    

    <section className="section">
      <div className="section-card hero">
        <div>
          <span className="eyebrow">Farmer Corner</span>
          <h1>This is the page of the great ZFAST Parivaar</h1>
          <p className="lead">Stay updated with practical dairy farming guidance, animal care tips, competition preparation, breeding awareness, body condition scoring, useful calculators, and farmer-focused learning resources.</p>
          <div className="hero-stats">
            <span className="pill">Dairy Knowledge</span>
            <span className="pill">Animal Nutrition</span>
            <span className="pill">Farmer First</span>
          </div>
        </div>
        <div className="hero-visual">
          <img src={new URL("/images/farmer-corner/zfast-farmer.webp", import.meta.url).href} alt="Smiling farmer illustration" />
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-card split">
        <div className="image-box center icon-img">
          <img src={new URL("/images/farmer-corner/winning-cow-illustration.webp", import.meta.url).href} alt="Champion cow illustration" />
        </div>
        <div>
          <span className="eyebrow">Champion Animal</span>
          <h2>Don’t miss out. Your cow or buffalo may be a champion!</h2>
          <p>Many dairy farmers are improving animal genetics and preparing their animals for dairy fairs. With the right records, nutrition, breeding plan, and expert guidance, every farmer can present animals with more confidence.</p>
          <div className="decor-line"></div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-card split reverse">
        <div>
          <span className="eyebrow">Preparation Checklist</span>
          <h2>Points to remember while preparing animals for competition</h2>
          <ul>
            <li>Keep complete breeding records of the animal.</li>
            <li>Maintain milk production records of the mother.</li>
            <li>Track previous lactation records of the animal.</li>
            <li>Plan breeding dates so the animal calves about 30–45 days before the competition.</li>
            <li>Start preparation from the dry and transition period with balanced feeding.</li>
            <li>Provide a clean, comfortable, and stress-free environment.</li>
            <li>Balance the total mixed ration after consultation with a dairy nutrition expert.</li>
          </ul>
          <div className="note-box">Right, you are set. All the very best, champions!</div>
        </div>
        <div className="image-box">
          <img src={new URL("/images/farmer-corner/zfast-farmer-corner-hero.webp", import.meta.url).href} alt="Winning dairy cow with farmers" />
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-card split">
        <div className="image-box center icon-img">
          <img src={new URL("/images/farmer-corner/zfast-ai-icon.webp", import.meta.url).href} alt="Artificial insemination icon" />
        </div>
        <div>
          <span className="eyebrow">Breeding Awareness</span>
          <h2>AI Guidelines</h2>
          <ul className="ai-list">
            <li><strong>Proper heat detection:</strong> Heat observation is essential for successful breeding. Farmers should monitor animal behavior carefully and inseminate when clear standing heat signs are visible.</li>
            <li><strong>Time of AI:</strong> Timely artificial insemination improves conception chances. Animals observed in heat in the morning are commonly inseminated later the same day, and animals observed in the afternoon are usually inseminated the next morning.</li>
            <li><strong>Semen straw handling:</strong> The AI tank should always contain sufficient nitrogen. Semen straws must be handled carefully and thawed at the correct temperature range.</li>
            <li><strong>Loading the AI gun:</strong> Keep equipment clean and warm, cut the straw properly, and fit a sterile sheath before insemination.</li>
            <li><strong>Recto-vaginal method:</strong> The animal should be clean and standing. Proper hygiene, careful handling, and trained technique are important for successful insemination.</li>
          </ul>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-card">
        <div className="section-title-center">
          <span className="eyebrow">Nutrition & Health</span>
          <h2>Body Condition Score (BCS)</h2>
          <p className="lead">Body condition affects productivity, reproduction, health, and long-term dairy performance. Managing nutrition during lactation helps minimize excess body condition loss and supports better outcomes.</p>
          <div className="decor-line"></div>
        </div>
        <div className="bcs-intro">
          <div>
            <p>High-yielding dairy animals use body reserves when dry matter intake lags behind energy demand. If condition loss becomes excessive, fertility and animal comfort may be affected.</p>
            <p className="muted">A balanced feed program with protein, energy, minerals, and vitamins helps support milk production while maintaining optimum body condition across different lactation stages.</p>
          </div>
          <div className="image-box center">
            <img src={new URL("/images/farmer-corner/zfast-farmer-corner-hero.webp", import.meta.url).href} alt="Animal nutrition benefits illustration" />
          </div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-card">
        <div className="section-title-center">
          <span className="eyebrow">BCS Scale</span>
          <h2>Body Condition Scoring Scale</h2>
          <p>BCS is a visual and tactile evaluation of body fat reserves, commonly observed around the rump and loin area. A lower score reflects a thinner animal, while a higher score reflects an over-conditioned animal.</p>
        </div>
        <div className="image-box">
          <img src={new URL("/images/farmer-corner/bcs-landmark.webp", import.meta.url).href} alt="Body condition score landmark illustration" />
        </div>
        <div className="bcs-scale">
          <div className="bcs-card"><img src={new URL("/images/farmer-corner/zfast-bcs-1.webp", import.meta.url).href} alt="BCS 1 cow" /><strong>BCS 1</strong></div>
          <div className="bcs-card"><img src={new URL("/images/farmer-corner/zfast-bcs-2.webp", import.meta.url).href} alt="BCS 2 cow" /><strong>BCS 2</strong></div>
          <div className="bcs-card"><img src={new URL("/images/farmer-corner/zfast-bcs-3.webp", import.meta.url).href} alt="BCS 3 cow" /><strong>BCS 3</strong></div>
          <div className="bcs-card"><img src={new URL("/images/farmer-corner/zfast-bcs-4.webp", import.meta.url).href} alt="BCS 4 cow" /><strong>BCS 4</strong></div>
          <div className="bcs-card"><img src={new URL("/images/farmer-corner/zfast-bcs-5.webp", import.meta.url).href} alt="BCS 5 cow" /><strong>BCS 5</strong></div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-card">
        <div className="section-title-center">
          <span className="eyebrow">Pig BCS Scale</span>
          <h2>Pig Body Condition Scoring Scale</h2>
          <p>Pigs also use a body condition scoring system. It helps farmers visually check whether an animal is too thin, in ideal condition, or over-conditioned by observing fat cover, spine, ribs, and hindquarter shape.</p>
        </div>

        <div className="pig-bcs-guide">
          <div className="pig-bcs-hero">
            <img src={new URL("/images/farmer-corner/zfast-pig-anatomy-landmark.webp", import.meta.url).href} alt="Generated sow body condition landmark reference" />
          </div>
          <div>
            <p className="lead">Pig BCS is commonly used to judge whether the sow or pig has enough body reserves for health, breeding performance, and productive growth. It is especially useful when reviewing feeding programs and overall condition.</p>
            <ul className="pig-bcs-points">
              <li>Check the ribs, backbone, hips, tail head, and fat cover.</li>
              <li>BCS 1 to 2 shows a thin animal needing closer feed review.</li>
              <li>BCS 3 is generally treated as the ideal target condition.</li>
              <li>BCS 4 to 5 shows a fat or obese animal needing feed control.</li>
            </ul>
          </div>
        </div>

        <div className="image-box" style={{ marginTop: '26px' }}>
        </div>

        <div className="pig-bcs-grid">
          <div className="pig-bcs-card">
            <img className="pig-bcs-photo" src={new URL("/images/farmer-corner/zfast-pig-body-condition-score-1.webp", import.meta.url).href} alt="Generated realistic pig BCS 1 very thin reference image" />
            <strong>BCS 1</strong>
            <p>Emaciated / very thin. Backbone and hips are very clear.</p>
          </div>
          <div className="pig-bcs-card">
            <img className="pig-bcs-photo" src={new URL("/images/farmer-corner/zfast-pig-body-condition-score-2.webp", import.meta.url).href} alt="Generated realistic pig BCS 2 thin reference image" />
            <strong>BCS 2</strong>
            <p>Thin condition. Bones can be felt easily with light pressure.</p>
          </div>
          <div className="pig-bcs-card">
            <img className="pig-bcs-photo" src={new URL("/images/farmer-corner/zfast-pig-body-condition-score-3.webp", import.meta.url).href} alt="Generated realistic pig BCS 3 ideal reference image" />
            <strong>BCS 3</strong>
            <p>Ideal condition. Balanced shape with controlled fat cover.</p>
          </div>
          <div className="pig-bcs-card">
            <img className="pig-bcs-photo" src={new URL("/images/farmer-corner/zfast-pig-body-condition-score-4.webp", import.meta.url).href} alt="Generated realistic pig BCS 4 fat reference image" />
            <strong>BCS 4</strong>
            <p>Fat condition. Extra cover is visible around the body.</p>
          </div>
          <div className="pig-bcs-card">
            <img className="pig-bcs-photo" src={new URL("/images/farmer-corner/zfast-pig-body-condition-score-5.webp", import.meta.url).href} alt="Generated realistic pig BCS 5 obese reference image" />
            <strong>BCS 5</strong>
            <p>Obese / very fat. Bones are hidden under heavy fat cover.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-card calculator-section">
        <span className="eyebrow">Useful Tools</span>
        <h2>Useful Calculators</h2>
        <p className="lead" style={{ marginLeft: 'auto', marginRight: 'auto' }}>Choose the animal type and explore simple farmer-friendly tools for body weight, feed products, and nutrition support.</p>

        
        <div className="tool-tabs" role="tablist" aria-label="Animal calculator tabs">
          <button className={`tool-tab ${activeTab === 'cow' ? 'active' : ''}`} type="button" role="tab" aria-selected={activeTab === 'cow'} onClick={() => setActiveTab('cow')}>Cows & Buffaloes</button>
          <button className={`tool-tab ${activeTab === 'pig' ? 'active' : ''}`} type="button" role="tab" aria-selected={activeTab === 'pig'} onClick={() => setActiveTab('pig')}>Pigs</button>
        </div>

        {activeTab === 'cow' && (
        <div className="tool-panel active" id="cow-tools" role="tabpanel">
          <div className="calculator-grid">
            <div>
              <h3>Useful Calculators for Cows & Buffaloes</h3>
              <p className="lead">Know your animal better, understand its nutrition needs, and choose the right feed or supplement guidance with easy farmer-friendly calculators.</p>
              <div className="calc-buttons">
                <a className="btn" href="/calculators/cattle">Ideal Body Weight</a>
                <a className="btn alt" href="/products#Cattle Feed">Feed Products</a>

              </div>
            </div>
            <img className="cow-gif" src={new URL("/images/farmer-corner/cattle-gif.gif", import.meta.url).href} alt="Animated cow" />
          </div>
        </div>
        )}

        {activeTab === 'pig' && (
        <div className="tool-panel active" id="pig-tools" role="tabpanel">
          <div className="calculator-grid">
            <div>
              <h3>Useful Calculators for Pigs</h3>
              <p className="lead">Just like the cow section, this pig section gives farmers a simple place to understand pig weight, feeding needs, and suitable nutrition support in an easy way.</p>
              <div className="calc-buttons">
                <a className="btn" href="/calculators/pig">Ideal Body Weight</a>
                <a className="btn alt" href="/products#Pig Feed">Pig Feed Products</a>

              </div>
            </div>
            <img className="pig-illustration" src={new URL("/images/farmer-corner/pig-gif.gif", import.meta.url).href} alt="Animated pig" />
          </div>
        </div>
        )}

      </div>
    </section>



  </main>
  




      </div>
    </PageShell>
  );
}
